<div class="blog-holder">
  <form (ngSubmit)="onAddArticle(articleForm)" #articleForm="ngForm">
    <div class="grid-x grid-margin-x">
      <div class="cell large-6 small-12">
        <label for="title">Title</label>
        <input type="text" id="title" name="title" required [(ngModel)]="formData.title" >
      </div>
      <div class="cell large-6 small-12">
        <label for="date">Date</label>
        <input type="date" id="date" name="date" required [(ngModel)]="formData.date" >
      </div>
      <div class="cell large-6 small-12">
        <label for="summary">Summary / subtitle</label>
        <textarea [(ngModel)]="formData.summary" name="summary" id="summary" cols="10" rows="5"></textarea>
      </div>
      <div class="cell large-12">
        <quill-editor class="quill-editor"
          name="content"
          [(ngModel)]="formData.content"
          [styles]="{height: '300px'}">
        </quill-editor>
      </div>
      <div class="cell large-4">
        <label for="imageIsFile">Image from link</label>
        <input type="checkbox" id="imageIsFile" name="imageIsFile" [(ngModel)]="formData.imageIsFile">
        @if (!formData.imageIsFile) {
          <div class="image-upload">
            <input type="file" id="fileElem"
              accept="image/*"
              (change)="addImage($event)">
            @if (formData.image) {
              <img [src]="formData.image" alt="">
            }
          </div>
        }
        @if (formData.imageIsFile) {
          <div class="file-link">
            <label for="fileLink">File link</label>
            <input type="text" id="fileLink" name="fileLink" [(ngModel)]="formData.fileLink" >
          </div>
        }
        <div class="large-6 small-12">
          <label for="picture_text">Picture Text</label>
          <input type="text" id="picture_text" name="picture_text" [(ngModel)]="formData.picture_text" >
        </div>
      </div>
      <div class="cell large-8">
        <app-image-picker class="image-picker-scroll"
          [images]="images"
          [selectedPaths]="image ? [image] : []"
          (select)="selectImage($event.path)"
          (deleted)="onImageDeleted($event)">
        </app-image-picker>
      </div>
    </div>
    <button class="button" type="submit" [disabled]="!articleForm.valid">Save</button>
  </form>
</div>
